import { styled } from '@zeiss/beyond-online-react';

import { Header as DefaultHeader } from './Header';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

/**
 * Container for the elements between the header and footer.
 */
const ContentContainer = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
`;

interface BaseProps {
  children?: React.ReactNode;
  footer: React.ReactNode;
}

interface FullPageWithCustomHeaderProps extends BaseProps {
  applicationTitle?: never;
  /**
   * Used as the application header instead of the default header
   */
  header: React.ReactNode;
}

interface FullPageWithDefaultHeaderProps extends BaseProps {
  /**
   * Used as the `applicationTitle` for the default header. Must be provided if
   * the `header` prop is not specified
   */
  applicationTitle: string;
  header?: never;
}

export type FullPageLayoutProps =
  FullPageWithCustomHeaderProps | FullPageWithDefaultHeaderProps;

/**
 * Full Page Layout
 *
 * ┌──────────────┐
 * │──────────────│
 * │ xx           │
 * │              │
 * │              │
 * │──────────────│
 * └──────────────┘
 *
 * @remarks
 * Barebone layout that displays the page content between a header and footer.
 *
 * @todo
 * Should be replaced with official
 * {@link https://beyond.zeiss.com/d/V6diyrWaeh1V/patterns#/-/ui-shell/variant-without-side-navigation | UI Shell}
 * (Without Side Navigation variant) once available.
 */
export const FullPageLayout = ({
  applicationTitle,
  children,
  footer,
  header,
}: FullPageLayoutProps) => {
  return (
    <PageContainer>
      {applicationTitle ? (
        <DefaultHeader applicationTitle={applicationTitle} />
      ) : (
        header
      )}

      <ContentContainer>{children}</ContentContainer>

      {footer}
    </PageContainer>
  );
};
